// requireAdmin.jsx
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './context/AuthContext'; // 1. ייבוא הקונטקסט

export default function RequireAdmin({ children }) {
    // 2. שימוש ב-Context כדי לקבל את המידע העדכני ביותר
    const { isAuthenticated, user, loading } = useContext(AuthContext);
    const location = useLocation();

    // 3. בזמן שהמידע על המשתמש נטען, נציג הודעת טעינה
    if (loading) {
        return <div>טוען אימות...</div>;
    }

    // 4. אם המשתמש מחובר והוא אדמין, נציג את העמוד המבוקש
    if (isAuthenticated && user?.role === 'admin') {
        return children;
    }

    // 5. אם הוא לא מחובר או לא אדמין, נשלח אותו להתחברות
    // אנו שומרים את הנתיב שאליו ניסה להגיע כדי להחזיר אותו לשם אחרי ההתחברות
    return <Navigate to="/login" state={{ from: location }} replace />;
}